export default __webpack_public_path__ + "static/lutein-prevantivno-Lutein-164289d189608f185ed317e6803fcf25.jpg";